import React, { Component } from 'react'
import ActivityAndMembersCard from '../../../../components/availabilityActivityComponents/ActivityAndMembersCard'
import { Typography } from '@material-ui/core'

export default class ViewServiceProfessionals extends Component {

  onEndIconClickHandler = (id) => {
    
    if(id) this.props.onEndIconClickHandler(id,true)
  }


  render() {
    const { data } = this.props

    return (
      <div>
        <Typography variant="h6" style={{ padding: "14px 14px 14px 14px" }}>
          {data?.service_professionals?.length ? data?.service_professionals?.length : 0} Service Professional(s)</Typography>
        {data && data?.service_professionals?.map((item, index) => {
          return (
            <ActivityAndMembersCard
              key={index}
              data={item}
              id={item.id}
              profilePicture={item?.profile_pic}
              title={item?.name}
              name={item?.care_provider?.name}
              onEndIconClickHandler={this.onEndIconClickHandler}
              status={item?.isactive}
            />
          )
        })}
        {/* <Typography>View all Service Professional Screen Needed</Typography> */}
      </div>
    )
  }
}
